import React from "react";
import { Link } from "react-router-dom";

export const ItemsSlider = props => {
    const { link, img, name, amount, id } = props;
    return (
        <Link to={link} className="glide__slide sliderPlanes--li">
            <div className="autoName">{name}</div>
            <img src={`${img}`} />
            <p className="cuota">
                Cuota desde <strong className="bold">${amount}</strong>
            </p>
            <button className="btn-sliderPlanes">
                <p>Conocé más</p>
            </button>
        </Link>
    );
};
